module.exports = __webpack_public_path__ + "img/sanroom-card.9c6e6d8f.png";